<template>
<div class="NationalDistribution">
    <el-container class="panel planet">
        <el-aside class="nav box-shadow">
            <div class="logo"></div>
            <nationalDistributionMenu class="nav-fixed"></nationalDistributionMenu>
        </el-aside>
        <el-container class="is-vertical">
            <nationalDistributionHeader></nationalDistributionHeader>
            <el-main class="padding-20">
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
    <loading v-show="loading"></loading>
</div>
</template>

<script>
import NationalDistributionMenu from 'base/menu/nationalDistributionMenu'
import NationalDistributionHeader from 'base/wHeader/nationalDistributionHeader'
import Loading from 'base/loading/loading'
import {mapGetters} from 'vuex'
export default {
    name: 'NationalDistribution',
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters([
            'loading'
        ])
    },
    components: {
        NationalDistributionMenu,
        NationalDistributionHeader,
        Loading
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
@import "~common/scss/mixin";
.NationalDistribution {
    .panel {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
    .planet {
        .logo:before {
            background-image: url('~common/images/nationalDistributionMenu/logo.png');
            background-repeat: no-repeat;
            background-size: 100%;
        }
        .nav .nav-fixed {
            width: 181px !important;
        }
    }
    .nav{
        background: $bgcolor-white;
        width: 180px !important;
        position: relative;
        overflow: hidden;
        .logo{
            height: 75px;
        }
        .nav-fixed{
            position: absolute;
            top: 75px;
            bottom: 0;
            width: 200px !important;
            overflow-y: scroll;
            overflow-x: hidden;
            &::-webkit-scrollbar{
                display:none
            }
        }
    }
    .is-vertical{
        min-width: 1000px;
    }
    .el-main{
        background: $bgcolor-global;
        /*overflow-x: hidden;*/
    }
    .filters {
        .el-button {
            height: 36px;
            line-height: 36px;
        }
    }
    .el-icon-info {
        color: #C0C4CC;
    }
    .box-detail{
        flex-grow: 1;
        .box-title{
            font-size: $font-12;
        }
        .box-data{
            margin-top: 12px;
            font-size: $font-16;
            color: $tcolor-blue;
            .data{
                font-size: $font-24;
            }
        }
    }
}
</style>
